<template>
    <div>
        <!-- <p class="text-primary mb-4">{{ object_data.description }}</p> -->
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onClickCreateObject)" autocomplete="off">
                <div class="vx-row mb-3">
                    <div class="vx-col w-full mb-3" v-if="isFieldVisible(field)"
                        :class="{ 'md:w-1/2': !['textarea', 'dynamic_form'].includes(field.type) }"
                        v-for="(field, index) in object_data.fields" :key="index">
                        <ValidationProvider :vid="field.name" :name="field.name"
                            :rules="field.required ? 'required' : ''" v-slot="{ errors }">
                            <small class="label">{{ field.label }}</small> <small class="text-danger ml-4"
                                v-if="field.required && !form[field.name]">*This field is required</small>

                            <span v-if="field.type === 'text'">
                                <vs-input :disabled="field.isDisabled" v-model="form[field.name]" :name="field.name"
                                    class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                                    val-icon-danger="icon-x" val-icon-pack="feather" />
                            </span>

                            <span v-if="field.type === 'dropdown'">
                                <v-select :disabled="field.isDisabled" :clearable="true" v-model="form[field.name]"
                                    :reduce="option => option" :options="field.options.static">
                                </v-select>
                            </span>

                            <span v-if="field.type === 'multiselect'">
                                <v-select :disabled="field.isDisabled" :clearable="true" v-model="form[field.name]"
                                    :reduce="option => option" :options="field.options.static" multiple class="w-full">
                                </v-select>
                                <!-- <vs-button v-if="isSelectAllVisible(field.name, field.options.static)"
                    @click.stop="onClickSelectAll(field.name, field.options.static)" type="border"
                    class="mt-2 float-right" size="small">Select All</vs-button>
                  <vs-button v-if="!isSelectAllVisible(field.name, field.options.static)"
                    @click.stop="onClickClearAll(field.name, field.options.static)" type="border"
                    class="mt-2 float-right" size="small" color="danger">Clear All</vs-button> -->
                            </span>

                            <span v-if="field.type === 'phone'">
                                <vs-input :disabled="field.isDisabled" v-model="form[field.name]" :name="field.name"
                                    class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                                    val-icon-danger="icon-x" val-icon-pack="feather" />
                            </span>

                            <span v-if="field.type === 'url'">
                                <vs-input :disabled="field.isDisabled" v-model="form[field.name]" :name="field.name"
                                    class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                                    val-icon-danger="icon-x" val-icon-pack="feather" />
                            </span>

                            <span v-if="field.type === 'currency'">
                                <vs-input :disabled="field.isDisabled" v-model="form[field.name]" :name="field.name"
                                    class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                                    val-icon-danger="icon-x" val-icon-pack="feather" />
                            </span>

                            <span v-if="field.type === 'number'">
                                <vs-input :disabled="field.isDisabled" v-model="form[field.name]" :name="field.name"
                                    class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                                    val-icon-danger="icon-x" val-icon-pack="feather" type="number" />
                            </span>

                            <span v-if="field.type === 'email'">
                                <vs-input :disabled="field.isDisabled" v-model="form[field.name]" :name="field.name"
                                    class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                                    val-icon-danger="icon-x" val-icon-pack="feather" />
                            </span>

                            <span v-if="field.type === 'textarea'">
                                <vs-textarea :disabled="field.isDisabled" v-model="form[field.name]" :name="field.name"
                                    class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                                    val-icon-danger="icon-x" val-icon-pack="feather" />
                            </span>

                            <span v-if="field.type === 'date'">
                                <flat-pickr class="hidden w-full" v-model="form[field.name]" placeholder="" />
                                <flat-pickr :disabled="field.isDisabled" v-model="form[field.name]" placeholder=""
                                    class="w-full" />
                            </span>

                            <span v-if="field.type === 'datetime'">
                                <flat-pickr class="hidden w-full" v-model="form[field.name]" placeholder="" />
                                <flat-pickr :disabled="field.isDisabled" v-model="form[field.name]" placeholder=""
                                    class="w-full" />
                            </span>

                            <span v-if="field.type === 'checkbox'">
                                <YesNoToggle v-model="form[field.name]" :disabled="field.isDisabled" />
                            </span>

                            <span v-if="field.type === 'lookup'">
                                <v-select :disabled="field.isDisabled" :clearable="true" v-model="form[field.name]"
                                    :reduce="option => option[field.options.dynamic.valueField]"
                                    :options="lookup_options[field.options.dynamic.objectName]"
                                    :label="field.options.dynamic.displayField">
                                </v-select>
                            </span>

                        </ValidationProvider>
                    </div>
                </div>
                <div class="flex flex-wrap items-center justify-end mt-8">
                    <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
                    <vs-button @click="onClickReset" class="ml-4 mt-2 hidden" type="border" color="warning">Reset</vs-button>
                </div>
            </form>
        </ValidationObserver>
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ObjectRepository = RepositoryFactory.get('object');

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import YesNoToggle from '@/components/shared/YesNoToggle.vue'

export default {
    name: "ObjectForm",
    data() {
        return {
            object_data: {},
            form: {},
            lookup_options: {},
            is_on_create: true,
        }
    },
    props: {
        object_name: {
            type: String,
            required: true
        },
        method: {
            type: String,
            default: 'create'
        },
        form_data: {
            type: Object,
            default: () => ({})
        },
        object_id: {
            type: String,
            default: null
        }
    },
    mixins: [SuccessMessage, ErrorMessages],
    components: {
        'v-select': vSelect,
        flatPickr,
        YesNoToggle
    },
    async mounted() {
        this.is_on_create = this.method === 'create'
        if (this.is_on_create) {
            this.form = this.form_data
        } else {
            await this.fetchObjectDetailsData()
        }
        await this.fetchObjectData()
        if (this.is_on_create && Object.keys(this.form_data).length > 0) {
            const disabled_keys = Object.keys(this.form_data)
            this.object_data.fields.forEach((field) => {
                if (disabled_keys.includes(field.name)) {
                    field.isDisabled = true
                }
            })
        }
    },
    methods: {
        async fetchObjectData() {
            this.$vs.loading()
            try {
                const { data } = (await ObjectRepository.getObjectData(this.object_name)).data
                this.object_data = data

                const lookup_fields = this.object_data.fields
                    .filter(field => field.type === 'lookup')
                    .map((x) => x.options.dynamic.objectName)
                const unique_lookup_fields = [...new Set(lookup_fields)]
                if (unique_lookup_fields.length > 0) {
                    const lookup_options = await Promise.all(unique_lookup_fields.map(async (objectName) => {
                        const { data } = await ObjectRepository.fetchLookupData(objectName, this.form.Company && this.form.Company._id ? `account_id=${this.form.Company._id}` : (this.form.Company ? `account_id=${this.form.Company}` : ''))
                        return { [objectName]: data.data.data }
                    }))
                    this.lookup_options = lookup_options.reduce((acc, x) => ({ ...acc, ...x }), {})
                }

            } catch (e) {
                this.$vs.loading.close()
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close()
        },
        async fetchObjectDetailsData() {
            try {
                const { data } = (await ObjectRepository.getObjectDetails(this.object_name, this.object_id)).data
                this.form = data
                this.$emit('getObjectData', data)
            } catch (error) {

            }
        },
        async onClickCreateObject() {
            try {
                if (this.is_on_create) {
                    await ObjectRepository.createObject(this.object_name, this.form)
                } else {
                    await ObjectRepository.updateObject(this.object_name, this.form._id, this.form)
                }
            } catch (error) {

            }
        },
        onClickReset() {
            this.form = {}
        }, onClickSelectAll(name, options) {
            if (!this.form[name]) {
                this.form[name] = []
            }
            this.form[name].splice(0, this.form[name].length)
            options.map((option) => {
                this.form[name].push(option)
            })
        },
        onClickClearAll(name, options) {
            this.form[name] = []
        },
        isSelectAllVisible(name, options) {
            return !this.form[name] || this.form[name].length !== options.length
        },
        isFieldVisible(field) {
            if (field.isHidden) {
                return false
            }
            if (!field.visibilityCondition) {
                return true; // No condition, always visible
            }

            const { logic = "AND", rules } = field.visibilityCondition;

            if (!Array.isArray(rules) || rules.length === 0) {
                return true; // If no rules exist, default to visible
            }

            const results = rules.map(rule => {
                const dependsOnField = rule.dependsOn;

                // Check if the field exists in the form data
                if (!this.form.hasOwnProperty(dependsOnField)) {
                    return false; // Hide the field if the dependency is missing
                }

                const fieldValue = this.form[dependsOnField];
                const conditionValue = rule.value;

                switch (rule.operator) {
                    case "equal":
                        return fieldValue === conditionValue;
                    case "notEqual":
                        return fieldValue !== conditionValue;
                    case "greaterThan":
                        return fieldValue > conditionValue;
                    case "lessThan":
                        return fieldValue < conditionValue;
                    case "exists":
                        return fieldValue !== undefined && fieldValue !== null && fieldValue !== "";
                    case "notExists":
                        return fieldValue === undefined || fieldValue === null || fieldValue === "";
                    default:
                        return false;
                }
            });

            return logic === "AND" ? results.every(Boolean) : results.some(Boolean);
        },
    }
}
</script>
<style lang="">

</style>